import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { useOperatorTailContext } from 'src/contexts/operator-tail.context';
import { getOperatorTailStatus } from 'src/selectors/operator-tail.selector';
import { actionTypes } from 'src/ducks/operator-tail.duck';
import OperatorTailsForm from '../operator-tail-number-relationship-form/operator-tail-number-relationship-form.component';
import styles from '../operator-tail-number-relationship-list/operator-tail-number-relationship-list.module.scss';

const OperatorTailsAdd: React.FC = () => {
  const { state, actions } = useOperatorTailContext();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const addStatus = getOperatorTailStatus(
    state,
    actionTypes.OPERATOR_TAIL_NUMBER_ADD
  );

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (formData) => {
      const response = await actions.addPOST(formData);
      if (!response.error) {
        ToastSuccess(Lang.MSG_OPERATOR_TAIL_NUMBER_ADD_SUCCESS);
      } else {
        ToastError(response.error.message);
      }
      setIsAddOpen(false);
      actions.listGET();
    },
    [actions, setIsAddOpen]
  );

  return (
    <ATMModal
      open={isAddOpen}
      size="tiny"
      trigger={
        <ATMButton
          basic
          color="blue"
          content={Lang.LBL_NEW}
          icon="plus"
          floated="right"
          onClick={() => setIsAddOpen(true)}
        />
      }
      header={Lang.LBL_ADD_OPERATOR_TAIL_NUMBER}
      content={
        <div className={styles.content}>
          <OperatorTailsForm
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={styles.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsAddOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || addStatus.fetching}
            onClick={handleSave}
            loading={addStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default OperatorTailsAdd;
